const STORAGE_KEY = "reshet_device_tier";
const HANDHELD_RE =
  /urovo|dt50|dt40|dt30|dt20|dt70|rt40|i6310|honeywell|zebra|cipherlab|newland|sunmi|datalogic|unitech|pointmobile|chainway|seuic|handheld/i;

let cachedTier = null;

function readOverride() {
  try {
    const q = new URLSearchParams(window.location.search).get("deviceTier");
    if (q === "constrained" || q === "modern") {
      localStorage.setItem(STORAGE_KEY, q);
      return q;
    }
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "constrained" || stored === "modern") return stored;
  } catch {
    /* ignore */
  }
  return null;
}

function looksLikePdaScreen() {
  const dpr = window.devicePixelRatio || 1;
  const sw = window.screen?.width || 0;
  const sh = window.screen?.height || 0;
  const physMin = Math.round(Math.min(sw, sh) * dpr);
  const physMax = Math.round(Math.max(sw, sh) * dpr);
  return physMin >= 640 && physMin <= 800 && physMax >= 1280 && physMax <= 1600 && dpr <= 2.25;
}

export function detectDeviceTier() {
  if (typeof window === "undefined") return "modern";

  const override = readOverride();
  if (override) return override;

  const ua = `${navigator.userAgent || ""} ${navigator.platform || ""}`;
  if (HANDHELD_RE.test(ua)) return "constrained";

  // אייפון / מחשב — תמיד ממשק מלא
  if (/iphone|ipad|ipod|macintosh|mac os|windows/i.test(ua) && !/android/i.test(ua)) {
    return "modern";
  }

  const memory = Number(navigator.deviceMemory) || 0;
  if (memory > 0 && memory <= 2) return "constrained";

  const isAndroid = /android/i.test(ua);
  if (isAndroid && looksLikePdaScreen()) return "constrained";

  return "modern";
}

export function getDeviceTier() {
  if (!cachedTier) cachedTier = detectDeviceTier();
  return cachedTier;
}

export function isConstrainedDevice() {
  return getDeviceTier() === "constrained";
}

export function applyDeviceTierToDocument(tier = getDeviceTier()) {
  if (typeof document === "undefined") return;
  const html = document.documentElement;
  html.classList.toggle("device-constrained", tier === "constrained");
  html.classList.toggle("device-modern", tier === "modern");
  html.dataset.deviceTier = tier;
}

function setTier(next) {
  cachedTier = next;
  applyDeviceTierToDocument(next);
  window.dispatchEvent(new CustomEvent("reshet-device-tier", { detail: { tier: next } }));
}

/** השלמה אסינכרונית לפי מודל המכשיר (Chrome) */
export function refineDeviceTierFromHints() {
  const uaData = navigator.userAgentData;
  if (!uaData?.getHighEntropyValues) return;
  uaData
    .getHighEntropyValues(["model", "platform"])
    .then((info) => {
      const blob = `${info.model || ""} ${info.platform || ""}`;
      if (HANDHELD_RE.test(blob) && cachedTier !== "constrained") {
        setTier("constrained");
      }
    })
    .catch(() => {});
}
